import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import tinycolor from 'tinycolor2';

import { joinClassNames } from '../../../util/util';
import * as QPlayerSVGElement from '../../QPlayerSVGElement';
import ControlButton from '../ControlButton';

import './CenterControls.scss';

interface CenterControlsProps {
	settings?: any;
	playerHover?: boolean;
	isMobile?: boolean;
	isMaintainProportions?: boolean;
	queryParams?: any;
    className?: string;
}

export const StoryCenterControls = ({ settings, className }: CenterControlsProps) => {
    const { t } = useTranslation();
    const { isPlaying } = useSelector((state) => (state as any).playerReducer);
    const { currentMediaId, playlistId } = useSelector((state) => (state as any).configurationReducer);

    const [showPlayButton, setShowPlayButton] = React.useState(true);

	const currentPlayerId = `player-${playlistId || currentMediaId}`;
    const color = settings?.playerStyling?.primaryColor ?? '#126cfc';
    const opacity = Number(settings?.playerStyling?.primaryOpacity ?? 100);
    const rgbaWithOpa = { ...tinycolor(color).toRgb(), a: opacity / 100 };
    const hoverStyle = { backgroundColor: tinycolor(rgbaWithOpa).toRgbString() };
    const solidColor = settings?.controls?.solidBackgroundColor ?? '#000000';
    const solidColorStyle = settings?.controls?.showSolidBackgroundControl
        ? {
                backgroundColor: tinycolor({
                    ...tinycolor(solidColor).toRgb(),
                    a: Number(settings?.controls?.solidBackgroundControlOpacity ?? 100) / 100,
                }).toRgbString(),
            }
        : {};

    const handleButtonPlay = useCallback(() => {
        (window as any).GoBrain.widgets(currentPlayerId)?.play?.();
    }, [currentPlayerId]);

    const handleButtonPause = useCallback(() => {
        (window as any).GoBrain.widgets(currentPlayerId)?.pause?.();
    }, [currentPlayerId]);

    useEffect(() => {
        setShowPlayButton(!isPlaying);
    }, [isPlaying]);

    return (
		<div className={joinClassNames('controlsOverlayCenterControls--story', className)}>
			<ControlButton
				tabIndex={0}
				ariaLabel={isPlaying ? t('PAUSE') : t('PLAY')}
				className="controlsOverlayCenterControls__play-btn"
                onClick={isPlaying ? handleButtonPause : handleButtonPlay}
				tooltip={isPlaying ? t('PAUSE') : t('PLAY')}
				icon={<QPlayerSVGElement.Play />}
                hoverStyle={hoverStyle}
                style={{
                    ...solidColorStyle,
                    opacity: showPlayButton ? '1' : '0',
                    transform: showPlayButton ? "translate(-50%, -50%) scale(1.2)" : ""
                }}
			/>
		</div>
	);
}